import { createFileRoute, useSearch } from '@tanstack/react-router';
import { ContainerTypeLegacy, ExportTelemetryForm } from '@amber-ui/core';

function PileExportTelemetryRoute() {
  const { pile } = useSearch({ strict: false }) as { pile?: string };
  const pile_id = pile || null;

  if (!pile_id) return null;

  return <ExportTelemetryForm container_id={pile_id} container_type={ContainerTypeLegacy.pile} />;
}

export const Route = createFileRoute('/_auth/_pile/pile/export_telemetry')({
  component: PileExportTelemetryRoute,
});
